import { type FullyQualifiedTopic, type Subscription } from '@/context/messaging/general';
import { EVENTS_TOPIC } from '@/context/messaging/mqtt';

// e.g. events/v2/picking/picker-profiles/Ekko/profile1/order-update
export function getFullyQualifiedTopic({
  version,
  namespace,
  identifier,
  type,
}: Omit<Subscription, 'socketId'>): FullyQualifiedTopic {
  return `${EVENTS_TOPIC}/${version}/${namespace}/${identifier}/${type}`;
}
